import { useState, useContext, useMemo } from 'react';
import { Checkbox, message } from 'antd';
import { FolderOutlined } from '@ant-design/icons';
import PSAIModal from '@PSAIComponents/PSAIModal';
import HoverActions from '../HoverActions';
import FolderNameModal from '../FolderNameModal';
import MoveFolderModal from '../MoveFolderModal';
import ImagePreviewModal from '../ImagePreviewModal';
import { MaterialManageContext } from '../../hooks/MaterialManageContext';
import API from '@api/api';
import styles from './index.module.scss';
import utils from '@utils/utils';
import Iconfont from '@utils/Iconfont';

const MaterialCard = (props) => {
    const { item, selected, batchMode, onSelect } = props;
    const { activeTab, activeMenu, searchKeyword, fetchMaterialList, fetchFolderTree, menuList, setPageIndex, selectFolderWithExpand } = useContext(MaterialManageContext);
    const [renameOpen, setRenameOpen] = useState(false);
    const [moveOpen, setMoveOpen] = useState(false);
    const [shareOpen, setShareOpen] = useState(false);
    const [previewOpen, setPreviewOpen] = useState(false);
    const isFailed = useMemo(() => {
        return item?.attr?.status === 'failed' || item?.attr?.maskStatus === 'failed';
    }, [item]);

    const handleDelete = () => {
        PSAIModal.confirm({
            content: (
                <div style={{ textAlign: 'center' }}>
                    <p>确定要删除此参考图吗？</p>
                    <p style={{ color: '#FF3B30' }}>此操作不可复原，请确认是否删除</p>
                </div>
            ),
            onOk: () => {
                return API.materialResDelete({ resIds: [item.id] })
                    .then((res) => {
                        if (res.code === 0) {
                            message.success('删除成功');
                            refreshList();
                        } else {
                            message.error(res.message || '删除失败');
                        }
                    })
                    .catch(() => {
                        message.error('删除失败，请稍后重试');
                    });
            },
        });
    };

    const refreshList = () => {
        const folderId = activeMenu === 'refImage_all' ? '' : (activeMenu || '');
        fetchMaterialList({
            scope: activeTab,
            folderId,
            keyword: searchKeyword,
            pageIndex: 1,
        });
        fetchFolderTree(activeTab);
    };

    const handleFolderTagClick = (e) => {
        e.stopPropagation();
        if (!item.folderId) return;
        // 只改状态，由 useEffect 统一触发 pageIndex=1 的请求，避免重复请求
        setPageIndex(1);
        selectFolderWithExpand(item.folderId, item.folderPath.split('/').pop());
    };

    const handleShare = () => {
        setShareOpen(true);
    };

    return (
        <div className={`${styles.MaterialCard} ${selected ? styles.selected : ''} ${batchMode ? styles.batchMode : ''}`}>
            {batchMode && (
                <Checkbox
                    className={styles.checkbox}
                    checked={selected}
                    onClick={(e) => e.stopPropagation()}
                    onChange={() => onSelect(item.id)}
                />
            )}
            <div
                className={styles.imageWrap}
                onClick={(e) => {
                    e.stopPropagation();
                    if (batchMode) {
                        onSelect(item.id);
                    } else {
                        setPreviewOpen(true);
                    }
                }}
            >
                {isFailed ? (
                    <div className={styles.MaterialCardFailed}>
                        {item.canManage !== false && <Iconfont type="icon-Material-DeleteOutlined" onClick={(e) => {
                            e.stopPropagation();
                            handleDelete();
                        }} className={styles.FailedDeleteIcon} />}
                        <p>生成失败</p>
                        <p>虹豆已退回</p>
                    </div>
                ) : (
                    <>
                        {item.url ? (
                            <img src={utils.getImgThumbnail(item.url)} alt={item.name} />
                        ) : (
                            <div className={styles.placeholder} />
                        )}
                        {item.canManage !== false && (
                            <HoverActions
                                className={styles.hoverActions}
                                onMove={handleShare}
                                onSort={() => setMoveOpen(true)}
                                onEdit={() => setRenameOpen(true)}
                                onDelete={handleDelete}
                            />
                        )}
                        {activeMenu === 'refImage_all' && item.folderPath && (
                            <div className={styles.folderTag} onClick={handleFolderTagClick}>
                                <FolderOutlined style={{ fontSize: 14, marginRight: 4, flexShrink: 0 }} />
                                <span>{item.folderPath.split('/').pop()}</span>
                            </div>
                        )}
                    </>
                )}
            </div>
            <div
                className={styles.info}
                onClick={(e) => {
                    e.stopPropagation();
                    if (batchMode) {
                        onSelect(item.id);
                    }
                }}
            >
                <p className={styles.name}>{item.name}</p>
                <p className={styles.time}>
                    {activeTab === 'enterprise' ? (
                        <>
                            {item.createdTime?.split(' ')[0] || item.createdTime}
                            <span style={{ marginLeft: 12, color: '#5B6673' }}>{item.memberName}</span>
                        </>
                    ) : (
                        item.createdTime
                    )}
                </p>
            </div>
            <FolderNameModal
                open={renameOpen}
                mode="renameRes"
                initialName={item.name || ''}
                renameId={item.id}
                onSuccess={() => {
                    setRenameOpen(false);
                    refreshList();
                }}
                onCancel={() => setRenameOpen(false)}
            />
            <MoveFolderModal
                open={moveOpen}
                mode="res"
                menuList={menuList}
                resIds={[item.id]}
                onSuccess={() => {
                    setMoveOpen(false);
                    refreshList();
                }}
                onCancel={() => setMoveOpen(false)}
            />
            <MoveFolderModal
                open={shareOpen}
                mode="share"
                resIds={[item.id]}
                shareScope="enterprise"
                onSuccess={() => {
                    setShareOpen(false);
                    refreshList();
                }}
                onCancel={() => setShareOpen(false)}
            />
            <ImagePreviewModal
                open={previewOpen}
                item={item}
                onClose={() => setPreviewOpen(false)}
                onRefresh={refreshList}
            />
        </div>
    );
};

export default MaterialCard;
